import React from 'react';
import './footer.css'; // Ensure you create a corresponding CSS file

function FooterComp() {
  return (
<footer className="footer">
  <div className="footer-container">

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/booking">Book a Taxi</a></li>
            <li><a href="/">Home</a></li>
            <li><a href="/aboutus">About Us</a></li>
            <li><a href="/contactus">Contact Us</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Informations</h4>
          <ul>
            <li><a href="/privacy">Privacy Policy</a></li>
            <li><a href="/terms">Terms & conditions</a></li>
            <li><a href="/faqs">FAQ</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact Info</h4>
          <p>No. 27, Buduruwagala, Wellawaya, Sri Lanka</p>
          <p><a href="tel:+94776937010"> +94 77 693 7010</a></p>
          <p><a href="mailto:infochavotours@gmail.com?subject=Tour Inquiry&body=Hi, I'm interested in your travel packages.">Email Chavo Tours</a></p>
        </div>

        <div className="footer-section">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="https://www.facebook.com/share/19aahNUzdu/" target="_blank" rel="noreferrer">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://x.com/chavotour?t=LcOsn3wP2xmcHSbIbace4w&s=09" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-x-twitter"></i>
            </a>

          
            <a href="https://www.threads.com/@chavotours" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-threads"></i>
            </a>

            <a href="https://www.instagram.com/chavotours?igsh=MXRrdnVscmxueDd2dg==" target="_blank" rel="noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Chavo Tours. All Rights Reserved. | Designed and Developed by 
  <a 
    className="glaxmore-link" 
    href="https://www.glaxmore.com" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    &ensp; GLAXMORE
  </a>
</p>
      </div>
    </footer>
  );
}

export default FooterComp;
